import RunningText from "components/RunningText";
import React from "react";

function Doctors() {
    const doctors = [
        {
            name: "Dr. Mohit Sikaa",
            photo: "/images/doctors/mohit.jpg",
            specialization: "General Physician",
            certifications: "MD (Medicine)",
            experience: "25+ Years",
            opd: "Mon – Sat | 9:00 AM – 2:00 PM",
            education: "MD (Medicine)",
            languages: "Hindi, English",
            phone: "+919685851615",
        },
        {
            name: "Dr. Jai Prakash Paliwal",
            photo: "/images/doctors/Paliwal.jpg",
            specialization: "General Surgeon",
            certifications: "MS (General Surgery)",
            experience: "30+ Years",
            opd: "Thursday | 9:00 AM – 2:00 PM",
            education: "MS (General Surgery)",
            languages: "Hindi, English",
            phone: "+919685851615",
        },
        {
            name: "Dr. Rajat Nagar",
            photo: "/images/doctors/rajat.jpg",
            specialization: "Orthopaedic Surgeon",
            certifications: "MS (Orthopaedics)",
            experience: "10+ Years",
            opd: "Sat 4:00–8:00 PM | Sun 2:00–6:00 PM",
            education: "MS (Orthopaedics)",
            languages: "Hindi, English",
            phone: "+919688581615",
        },
        {
            name: "Dr. Tarun Gavli",
            photo: "/images/doctors/tarun.jpg",
            specialization: "General Physician",
            certifications: "MBBS",
            experience: "3+ Years",
            opd: "9:00 AM – 2:00 PM | 5:00 PM – 10:00 PM",
            education: "MBBS – KIMS, Bhubaneswar",
            languages: "Hindi, English",
            phone: "+919685851615",
        },
    ];

    return (
        <div
            className="min-h-screen py-12 px-4"
            style={{
                background:
                    "linear-gradient(135deg, #0b3c78, #1e6fd9, #7cc7f5, #e7b7f3, #fde7f3)",
            }}
        >
            <h1 className="text-3xl md:text-4xl font-bold text-center text-white mb-10">
                Our Doctors & Consultants
            </h1>

            {/* ================= MAIN DOCTORS ================= */}
            <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
                {doctors.map((doc, index) => (
                    <div
                        key={index}
                        className="bg-white rounded-xl shadow-lg border border-gray-200 flex flex-col md:flex-row overflow-hidden"
                    >
                        <img
                            src={doc.photo}
                            alt={doc.name}
                            className="w-full md:w-64 h-64 object-cover"
                        />

                        <div className="p-6 flex-1">
                            <h2 className="text-2xl font-semibold text-gray-800">
                                {doc.name}
                            </h2>

                            <p className="text-blue-600 font-medium">
                                {doc.specialization}
                            </p>

                            <p className="text-sm text-gray-500 mt-1">
                                {doc.certifications}
                            </p>

                            <div className="mt-3 space-y-1 text-sm text-gray-700">
                                <p><b>Experience:</b> {doc.experience}</p>
                                <p><b>OPD:</b> {doc.opd}</p>
                                <p><b>Education:</b> {doc.education}</p>
                                <p><b>Languages:</b> {doc.languages}</p>
                            </div>

                            <a
                                href={`tel:${doc.phone}`}
                                className="mt-5 inline-block bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-lg transition text-center"
                            >
                                Book Appointment
                            </a>
                        </div>
                    </div>
                ))}
            </div>

            {/*  ================= Running Text ================= */}

            <RunningText />

            {/*  =================   Other Doctors & Visiting Specialties ================= */}

            <div className="max-w-6xl mx-auto mt-16">
                <h2 className="text-3xl font-bold text-blue-800 mb-6 text-center">
                    👨‍⚕️ Other Doctors & Visiting Specialties
                </h2>

                <p className="text-gray-700 mb-8 text-center">
                    In addition to our in-house doctors, Gavli Hospital is supported by
                    experienced visiting and on-call specialists across multiple disciplines.
                </p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {[
                        "Paediatrics (Child Health & Vaccination)",
                        "Obstetrics & Gynaecology (Women’s Health Care)",
                        "Anaesthesiology & OT Support",
                        "Radiology & Imaging Consultation",
                        "Pathology & Laboratory Services",
                        "ENT (Ear, Nose & Throat) Consultation",
                        "Physiotherapy & Rehabilitation Support",
                        "Diet & Nutrition Counselling",
                    ].map((service, idx) => (
                        <div
                            key={idx}
                            className="flex items-center p-4 bg-white rounded-xl shadow hover:shadow-lg transition border border-gray-200"
                        >
                            <span className="text-green-500 text-xl mr-3">✔</span>
                            <p className="text-gray-800 font-medium">{service}</p>
                        </div>
                    ))}
                </div>

                <div className="mt-8 bg-blue-50 border-l-4 border-blue-600 p-5 rounded-lg text-center">
                    <p className="text-blue-900 font-semibold">
                        ⭐ Visiting specialists are available as per schedule and patient requirements.
                    </p>
                    <p className="mt-2 text-blue-700">
                        ☎ Contact the hospital desk to confirm doctor availability.
                    </p>
                </div>
            </div>


        </div>
    );
}

export default Doctors;
